import { getEnvironmentNameFromId } from "environments/tools/common"
import { IForm, IFormChange } from "form/model"
import { getSspNameFromId } from "ssp/tools/common"
import { getFinalizedArrayChange } from "./change"
import { getCampaignSspDealId } from "./ssp-deal"

export function getScreensChanges(form: IForm): IFormChange[] {
  const previousData = form.context.initialData
  const previousSspIds = !previousData ? [] : previousData.screens.sspIds
  const previousEnvironmentIds = !previousData ? [] : previousData.screens.environmentsIds
  const previousOperatorIds = !previousData ? [] : previousData.screens.operators.map(o => o.id)
  const previousCampaignSspDealIds = !previousData
    ? []
    : previousData.screens.campaignSspDeals.map(s => getCampaignSspDealId(s.ssp_id, s.dealid))
  const changes: IFormChange[] = []
  changes.push(
    getFinalizedArrayChange("ssp.title", previousSspIds, form.screens.sspIds, (id: any) => getSspNameFromId(id))
  )
  changes.push(
    getFinalizedArrayChange("environments.title", previousEnvironmentIds, form.screens.environmentsIds, (id: any) =>
      getEnvironmentNameFromId(id)
    )
  )
  changes.push(
    getFinalizedArrayChange(
      "operators.title",
      previousOperatorIds,
      form.screens.operators.map(o => o.id),
      (id: any) => id
    )
  )
  changes.push(
    getFinalizedArrayChange(
      "dsp-deals.title",
      previousCampaignSspDealIds,
      form.screens.campaignSspDeals.map(s => getCampaignSspDealId(s.ssp_id, s.dealid)),
      (id: any) => id
    )
  )
  return changes
}
